import PropTypes from "prop-types";
import VolumeOffOutlinedIcon from "@mui/icons-material/VolumeOffOutlined";
import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";
import { styled } from "@mui/material/styles";

const StyledButton = styled("button")(({ theme }) => ({
  position: "absolute",
  top: 20,
  right: 20,
  backgroundColor: theme.palette.categorySliders.buttons.inactive,
  borderRadius: "50%",
  width: 40,
  height: 40,
  zIndex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  border: "none",
  "& svg": {
    color: "white",
  },
  "&:hover": {
    backgroundColor: theme.palette.categorySliders.buttons.active,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
    cursor: "pointer",
  },
}));

const VolumeButton = ({ onMute, muted = true }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onMute();
  };

  return (
    <StyledButton data-testid="volume-button" onClick={handleClick}>
      {muted ? <VolumeOffOutlinedIcon /> : <VolumeUpOutlinedIcon />}
    </StyledButton>
  );
};

VolumeButton.propTypes = {
  onMute: PropTypes.func.isRequired,
  muted: PropTypes.bool,
};

export default VolumeButton;
